// Who owns the body behind a content id, answered from the open deck (TODO §17.2.3).
//
// **This is the one genuinely new selector §17 needs**, and §17.6.2 needs it too. Every write
// of a heavy body used to be filed under `state.document.id` — there was no other possibility.
// Now a slide carrying a `link` is a nugget's slide, and its grid body, diagram scene, gantt
// schedule and image blobs all belong to the NUGGET: written under the deck instead, the body
// forks, the four other decks keep rendering the old one, and nothing anywhere says so.
//
// The lookup is docId → the slide that holds it → that slide's owner. A scan of the slides
// rather than an index, because a deck has tens of slides and this runs on a ~400ms debounce
// that already crossed an iframe boundary.
//
// An id no slide claims resolves to the DECK. That is the right default and not a fallback:
// the only way to reach it is a body written in the same tick the window is being pointed at
// it, and a deck-owned body is what an unclaimed one is.

import { slideContentRefs } from "@/lib/contentRefs";
import { deckOwner, nuggetOwner } from "@/lib/ownerKey";
import type { SlideData } from "@/types/document";

interface OwnerLookupState {
  document: { id: string; slides: SlideData[] };
}

// The slide holding this content id, whatever kind of body it is.
export function slideHoldingContentDoc(
  slides: SlideData[],
  docId: string,
): SlideData | undefined {
  return slides.find((slide) =>
    slideContentRefs(slide.contents).some((ref) => ref.id === docId),
  );
}

// The owner key to file this body under. Pass the whole store state (or the two fields of it
// this needs) — the persistence listener and the diagram editor both call it.
export function ownerForContentDoc(
  state: OwnerLookupState,
  docId: string,
): string {
  const slide = slideHoldingContentDoc(state.document.slides, docId);
  return slide?.link
    ? nuggetOwner(slide.link.nuggetId)
    : deckOwner(state.document.id);
}
